<template>
  <div class="card">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'VCard'
}
</script>
<style lang="scss" scoped>
  .card {
    background:rgba(255,255,255,1);
    box-shadow:0px 2px 12px 0px rgba(79,117,162,0.07);
    border-radius:2px;
  }
</style>
